module.exports = __webpack_public_path__ + "static/img/const-content-4.3ab5eb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/const-content-4.png
// module id = Frvv
// module chunks = 0